import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/share.png'
import _imports_2 from '@/assets/img/community/bacheca_off.svg'
import _imports_3 from '@/assets/img/community/bacheca_on.svg'
import _imports_4 from '@/assets/img/community/info_off.svg'
import _imports_5 from '@/assets/img/community/info_on.svg'
import _imports_6 from '@/assets/img/community/stand_off.svg'
import _imports_7 from '@/assets/img/community/stand_on.svg'
import _imports_8 from '@/assets/img/community/forum_off.svg'
import _imports_9 from '@/assets/img/community/forum_on.svg'
import _imports_10 from '@/assets/img/community/calendar_off.svg'
import _imports_11 from '@/assets/img/community/calendar_on.svg'
import _imports_12 from '@/assets/img/community/shop_off.svg'
import _imports_13 from '@/assets/img/community/shop_on.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-20941025")

_pushScopeId("data-v-20941025")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_4 = { class: "tagsContainer" }
const _hoisted_5 = { class: "communityHeaderContainer" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "text-uppercase fs_14 greyBlue ln_12 d-block text-break-word" }
const _hoisted_8 = { class: "text-capitalize fs_14 orange ln_12 d-block" }
const _hoisted_9 = { class: "fs_11 greyBlue underlined d-flex ln_12 mt-1" }
const _hoisted_10 = {
  key: 0,
  class: "genericPadding"
}
const _hoisted_11 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_12 = { class: "fs_13 greyBlue text-uppercase" }
const _hoisted_13 = { class: "reteContainer m-0 mt-2" }
const _hoisted_14 = { class: "reteImage" }
const _hoisted_15 = {
  key: 1,
  class: "genericPadding"
}
const _hoisted_16 = { class: "tabsContainer" }
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "offImage"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "onImage"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "activeBar" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  class: "offImage"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  class: "onImage"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "activeBar" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  src: _imports_6,
  class: "offImage"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  src: _imports_7,
  class: "onImage"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "activeBar" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("img", {
  src: _imports_8,
  class: "offImage"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("img", {
  src: _imports_9,
  class: "onImage"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "activeBar" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("img", {
  src: _imports_10,
  class: "offImage"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("img", {
  src: _imports_11,
  class: "onImage"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "activeBar" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("img", {
  src: _imports_12,
  class: "offImage"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("img", {
  src: _imports_13,
  class: "onImage"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "activeBar" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_share_button = _resolveComponent("share-button")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_userimage = _resolveDirective("userimage")!

  return (_ctx.loaded)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", {
          class: "communityBgContainer",
          style: 'background-image: url(\'' + _ctx.$store.state.community.backgroundImage + '\');'
        }, [
          _createVNode("div", {
            class: "absoluteButton topLeft",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
          }, [
            _hoisted_2
          ]),
          _createVNode(_component_share_button, {
            class: "absoluteButton topRight",
            shareUrl: _ctx.shareUrl
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["shareUrl"]),
          _createVNode("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.$store.state.community.tags, (tag, i) => {
              return (_openBlock(), _createBlock("div", {
                class: "tag",
                key: i
              }, _toDisplayString(tag), 1))
            }), 128))
          ])
        ], 4),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", {
              class: "logo",
              style: 'background-image: url(\'' + _ctx.$store.state.community.logo + '\');'
            }, null, 4),
            _createVNode("div", {
              class: "majorInfoContainer",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openPeopleModal(_ctx.$store.state.community.likes)))
            }, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$store.state.community.title), 1),
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$store.state.community.type), 1),
              _createVNode("div", _hoisted_9, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$store.state.community.likes.length) + " ", 1),
                  _createVNode(_component_localized_text, {
                    localizedKey: 'app_iscritti',
                    text: 'iscritti'
                  })
                ])
              ])
            ])
          ]),
          ((_ctx.$store.state.community.communityType != _ctx.closeStatus || _ctx.$store.state.community.isLiked) && !_ctx.isAdmin && !_ctx.isOwner)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: ["secondaryButton w-50 ms-5", { bgGradient: _ctx.$store.state.community.isLiked }],
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.like && _ctx.like(...args)))
              }, [
                (_ctx.$store.state.community.isLiked)
                  ? (_openBlock(), _createBlock(_component_localized_text, {
                      key: 0,
                      localizedKey: "app_seguiGia",
                      text: "Segui già",
                      class: "fs_13 white"
                    }))
                  : (_ctx.$store.state.community.isLikeRequestSent)
                    ? (_openBlock(), _createBlock(_component_localized_text, {
                        key: 1,
                        localizedKey: "app_RichiestaGiàInviata",
                        text: "Richiesta già inviata!",
                        class: "fs_13 greyBlue"
                      }))
                    : (_openBlock(), _createBlock(_component_localized_text, {
                        key: 2,
                        localizedKey: "app_segui",
                        text: "Segui",
                        class: "fs_13 greyBlue"
                      }))
              ], 2))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.canSee)
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("span", _hoisted_12, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "app_amministratori",
                    text: "Amministratori",
                    class: "fs_13 greyBlue"
                  }),
                  _createTextVNode(" (" + _toDisplayString(_ctx.updatedCommunity.admins.length) + ") ", 1)
                ]),
                _createVNode(_component_localized_text, {
                  class: "fs_12 greyBlue text-uppercase",
                  localizedKey: "app_veditutti",
                  text: "Vedi tutti",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openPeopleModal(_ctx.updatedCommunity.admins)))
                })
              ]),
              _createVNode("div", _hoisted_13, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.updatedCommunity.admins, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "reteItem",
                    key: item.identifier + '_selected',
                    onClick: ($event: any) => (_ctx.openPerson(item))
                  }, [
                    _withDirectives(_createVNode("div", _hoisted_14, null, 512), [
                      [_directive_userimage, _ctx.$store.state.getUserImage(item.identifier)]
                    ])
                  ], 8, ["onClick"]))
                }), 128))
              ]),
              _createVNode(_component_localized_text, {
                class: "mt-4 d-block fs_14 greyBlue",
                localizedKey: "app_devifarpartedellacommunitypervedereidettagli",
                text: "Devi far parte della community per vedere i dettagli. Metti il like per inoltrare la richiesta di partecipazione."
              })
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode(_component_router_link, {
                  class: "tab",
                  replace: true,
                  to: { name: _ctx.bachecaRouteName }
                }, {
                  default: _withId(() => [
                    _hoisted_17,
                    _hoisted_18,
                    _createVNode(_component_localized_text, {
                      class: "fs_11",
                      localizedKey: "app_bacheca",
                      text: "Bacheca"
                    }),
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_router_link, {
                  class: "tab",
                  replace: true,
                  to: { name: _ctx.infoRouteName }
                }, {
                  default: _withId(() => [
                    _hoisted_20,
                    _hoisted_21,
                    _createVNode(_component_localized_text, {
                      class: "fs_11",
                      localizedKey: "app_info",
                      text: "Info"
                    }),
                    _hoisted_22
                  ]),
                  _: 1
                }, 8, ["to"]),
                (_ctx.isFiera)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "tab",
                      replace: true,
                      to: { name: 'fiera_communities' }
                    }, {
                      default: _withId(() => [
                        _hoisted_23,
                        _hoisted_24,
                        _createVNode(_component_localized_text, {
                          class: "fs_11",
                          localizedKey: "app_stand",
                          text: "Stand"
                        }),
                        _hoisted_25
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, {
                  class: "tab",
                  replace: true,
                  to: { name: _ctx.forumRouteName }
                }, {
                  default: _withId(() => [
                    _hoisted_26,
                    _hoisted_27,
                    _createVNode(_component_localized_text, {
                      class: "fs_11",
                      localizedKey: "app_forum",
                      text: "Forum"
                    }),
                    _hoisted_28
                  ]),
                  _: 1
                }, 8, ["to"]),
                (!_ctx.isEvent && !_ctx.isFiera)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      class: ["tab", _ctx.isEventsActive ? 'router-link-active':''],
                      replace: true,
                      to: { name: 'community_events' }
                    }, {
                      default: _withId(() => [
                        _hoisted_29,
                        _hoisted_30,
                        _createVNode(_component_localized_text, {
                          class: "fs_11",
                          localizedKey: "app_eventi",
                          text: "Eventi"
                        }),
                        _hoisted_31
                      ]),
                      _: 1
                    }, 8, ["class"]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.community.isCertified || _ctx.isOwner)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      class: "tab",
                      replace: true,
                      to: { name: _ctx.shopRouteName }
                    }, {
                      default: _withId(() => [
                        _hoisted_32,
                        _hoisted_33,
                        _createVNode(_component_localized_text, {
                          class: "fs_11",
                          localizedKey: "app_shop",
                          text: "Shop"
                        }),
                        _hoisted_34
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_router_view)
            ]))
      ]))
    : _createCommentVNode("", true)
})